import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Modal,
  Table,
} from "reactstrap";
import { Field, reduxForm } from "redux-form";
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';


import 'react-accessible-accordion/dist/fancy-example.css';
import Util from '../../../Common/util';
import API from '../../../Common/api';
import EyeIcon from "mdi-react/EyeIcon";
import EmailIcon from "mdi-react/EmailIcon";
import AccountSearchIcon from "mdi-react/AccountSearchIcon";
//import Select from "react-dropdown-select";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import renderFileInputField from "../../../../shared/components/form/FileInput";
import renderSelectField from "../../../../shared/components/form/Select";
import renderMultiSelectField from "../../../../shared/components/form/MultiSelect";
import $ from "jquery";
import readXlsxFile from "read-excel-file";
//import Util from "../../../Common/util";
import XLSX from "xlsx";
import Sheet from "../../../../images/BIN_MASTER_v1.xlsx";
import axios from "axios";
import { MDBDataTable } from "mdbreact";
//import API from "../../../Common/api";
import _ from "lodash";
import "./styles.css";
import DatePicker from "react-datepicker";

import LoadingOverlay from "react-loading-overlay";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import Alert from "reactstrap/lib/Alert";
//import styled, { css } from "styled-components";



var url = window.location.hostname;
var port = window.location.port;
var data_img = [];
var assign_arr= [];
var unassign_arr = [];
var data_type = "";
var From_Date_val;
var to_Date_val;

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.getCookie = this.getCookie.bind(this);
  
    this.accessCookie = this.accessCookie.bind(this);
    this.toggle = this.toggle.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.SuccessConfirmtoggle = this.SuccessConfirmtoggle.bind(this);
    this.getStoreList = this.getStoreList.bind(this);
    this.getSubGroupId=this.getSubGroupId.bind(this);
    this.UnAssign = this.UnAssign.bind(this);
    this.assignedOrdersList = this.assignedOrdersList.bind(this);
    this.Assign = this.Assign.bind(this);
    this.toggleOK = this.toggleOK.bind(this);
    this.toggle1 = this.toggle1.bind(this);
    this.toggle2 = this.toggle2.bind(this);
    this.getStationList = this.getStationList.bind(this);
    this.getStationStatus = this.getStationStatus.bind(this);


    this.state = {
        fromdate:"",
        todate:"",
      orderdata: [],
      variant_data: [],
      shelf_life_uom: [],
      ShowpopupLoader: false,
      showFilter: false,
      ShowConfirmLoader: false,
      stationType: [],
      stationStatus:[],
      unAssignOrder: [],
      assignOrder: [],
      isDisabledSearch: false,
      showConfirmError: false,
      group_id: "",
      selectedOutlet: "",
      selectedDistributor: "",
      selectedLocation: "",
      selectedOrder: "",
      order: [],
      row_data: [],
      arr_data: [],
      store: [],
      subStore:[],
      distributor:[],
      outlet:[],
      location: [],
      EditModal: false,
      hsn_value: "",
      loader1: false,
      showVariant: false,
      isDisabledApply: false,
      mc_code: false,
      hsn_code: [],
      applyPackSize: "",
      showTable: false,
      status_type: "1",
      apply: true,
      store_id: "",
      sub_store_id:"",
      task_id: "",
      polaris_id: "",
      task_type_value: "",
      request_id: "",
      showUnAssignedOrder: false,
      showFetchDispatchData: false,
      isChecked: false,
      disabledBtn: false,
      showData: false,
      showErrorMessage: false,
      apply1: true,
      total_value: "",
      total_quantity: "",
      modal: false,
      selectedGroup: "",
      selectedSubGroup:"",
      modal1: false,
      modal2: false,
      modalFailed: false,
      showAllItem: false,
      disabledReasonBtn: true,
      showInvalidItem: false,
      showProceedbtn: false,
      showReasonbtn: false,
      reasonCodeNeeded: false,
      SuccessConfirmmodal: false,
      modalReason: false,
      loadingconfirmbtn: false,
      loading: false,
      loading_overlay: false,
      url: window.location.hostname,
      port: window.location.port,
    };
  }

  Assign(){
      this.fetchDispatch();
  }

  UnAssign(){
      this.setState({
       
        loading_overlay: true,

      })
      const payload = {
        location: this.state.selectedLocation,
  };

API.post('/product/product_master/v1/orders/', { param: payload })
      .then((response) => {
       console.log(response.data.data.unassigned_orders);
       this.setState({
         showUnAssignedOrder: false,
        showAssignedOrder: true,
        unAssignOrder: response.data.data.unassigned_orders,
        assignOrder: response.data.data.assigned_orders,
        loading_overlay: false,
       })
      })
      .catch(function(error) {});

  }


  assignedOrdersList(){

     const payload = {
      location: this.state.selectedLocation,
  };

API.post('/product/product_master/v1/orders/', { param: payload })
      .then((response) => {
       console.log(response.data.data.unassigned_orders);
       this.setState({
        unAssignOrder: response.data.data.unassigned_orders,
        assignOrder: response.data.data.assigned_orders

       })
      })
      .catch(function(error) {});

  }

  AssignData(){
    this.setState({
      assignLoader: true,
      assignDisabled: true
    })
    console.log("this.state.arr_data", this.state.arr_data);
    var arrayData = this.state.arr_data.filter(
      (item) => item.isChecked === true
    );

    console.log("arrayData", arrayData)

     var arr = [];

    for (var i = 0; i < arrayData.length; i++) {
      arr.push(arrayData[i].id);
    }

    const payload = {
      location: this.state.selectedLocation,
      sub_grp_ids: arr,
  };

API.post('/picking/createpackingTaskData/v1/', { param: payload })
      .then((response) => {
        //alert(response.data.message);
        this.setState({
          variant1: response.data.data,
          loading_overlay: true,
          success_message: response.data.message,
          //SuccessConfirmmodal: false
        });
        console.log("response",response.data)
        if(response.data.status === true){
          this.toggle2();
        }else{
        this.Failedtoggle();
        }
        this.setState({
        SuccessConfirmmodal: false,
        showCreatedId: false,
        showSelectGroup: false,
        showNewGroup: false,
        assignLoader: false,
        assignDisabled: false,
        createDisabled: false
        })
        
        this.fetchDispatch();
      })
      .catch(function(error) {});

  }

  UnAssignData(){
    const payload = {
      location: this.state.selectedLocation,
      type: "unassign",
      group_id: this.state.selectedGroup,
      order_id: unassign_arr
  };

API.post('/product/product_master/v1/group/unassign/', { param: payload })
      .then((response) => {
        alert(response.data.message);
        this.setState({
          variant1: response.data.data,
          loading_overlay: true,
        });
        
        this.fetchDispatch();
      })
      .catch(function(error) {});

  }

  checkedSingle(index, ischecked,orderid) {
    
    var arr=[];
    console.log(this.state.binData);
    this.setState({
      loading_overlay: true
    })
    let newData = this.state.arr_data;
    if (newData[index].isChecked === false) {
      newData[index].isChecked = true;
      data_type = "assign";
      assign_arr.push(orderid);
      
    } else if (newData[index].isChecked === true) {
      newData[index].isChecked = false;
      data_type = "unassign";
      unassign_arr.push(orderid);
      
    }

    console.log(newData);
    this.setState({
      tableRowsMap: this.assembleDispatchData(newData),
      //binData: newData,
      arr_data: newData
    });

    

    
  }


  toggleOK() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  }

  toggle() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  }
  toggle1() {
    this.setState((prevState) => ({ modal1: !prevState.modal1 }));
  }


  toggle2() {
    this.setState((prevState) => ({ modal2: !prevState.modal2 }));
  }

  toggleFailed() {
    this.setState((prevState) => ({ modalFailed: !prevState.modalFailed }));
  }


  SuccessConfirmtoggle() {
    this.setState((prevState) => ({
      SuccessConfirmmodal: !prevState.SuccessConfirmmodal,
    }));
  }

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    }else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41"+":8090";
    } else {
      url = window.location.hostname+port;
    }
    
    sessionStorage.setItem('PUstore_id', '')
    sessionStorage.setItem('PUpolaris_id', '')
    sessionStorage.setItem('PUstatus_type', '')
    sessionStorage.setItem('PUtask_type_value', '')
    sessionStorage.setItem('PUtask_id', '')

  /* sessionStorage.setItem('store_id', this.state.store_id)
    sessionStorage.setItem('polaris_id', this.state.polaris_id)
    sessionStorage.setItem('status_type', this.state.status_type)
    sessionStorage.setItem('task_type_value', this.state.task_type_value)
    sessionStorage.setItem('task_id', this.state.task_id)
*/

    var cookieUsername = this.getCookie("token");
    var Location = this.getCookie("selectedLocation");
    var username = this.accessCookie("token");
    this.setState(
      {
        userName: cookieUsername,
        selectedLocation: Location,
        store_id: sessionStorage.getItem('store_id') == "null" ? "" : sessionStorage.getItem('store_id') ,
        polaris_id: sessionStorage.getItem('polaris_id') == "null" ? "" : sessionStorage.getItem('polaris_id') ,
        task_id: sessionStorage.getItem('task_id') == "null" ? "" : sessionStorage.getItem('task_id') ,
        status_type: sessionStorage.getItem('status_type') == "null" || sessionStorage.getItem('status_type') == "" ? "1" : sessionStorage.getItem('status_type') ,
        task_type_value: sessionStorage.getItem('task_type_value') == "null" ? "" : sessionStorage.getItem('task_type_value')

      },
      () => {
        //this.fetchDispatch();
        // this.getStoreList();
        // this.getStationList();
        // this.getSubGroupId();
        // this.getStationStatus();
      }
    );
  }

  

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

 

   getStationList() {
    const payload = {
      location: this.state.selectedLocation,
  };

API.post('/product/product_master/v1/station/type/', { param: payload })
      .then((response) => {

       console.log(response);
        this.setState({ stationType: response.data.data });
      })

      .then(async () => {
        
      });

   
  }

  getStationStatus() {
    const payload = {
      location: this.state.selectedLocation,
  };

API.post('/product/product_master/v1/station/type/', { param: payload })
      .then((response) => {

       console.log(response);
        this.setState({ stationStatus: response.data.data });
      })

      .then(async () => {
        
      });
  }

  getStoreList() {
       const payload = {
        request_type: "inventory",
        screen_type: "party_packed"
  };

API.post('/product/product_master/v1/group/detail/', { param: payload })    
  .then((response) => response.data)

      .then((data) => {
       console.log(data);
        this.setState({ store: data.data });
      })

      .then(async () => {
        
      });
  }

  getSubGroupId() {
    
    const payload = {
      screen_type: "party_packed"
  };

API.post('/product/product_master/v1/subgroup/', { param: payload })

    .then((response) => response.data)

    .then((data) => {
     console.log(data);
      this.setState({ subStore: data.data });
    })

    .then(async () => {
      
    });
}

  createGroup() {

    this.SuccessConfirmtoggle();
    
  }


  handleChange1 = (e) => {
    this.setState({
      selectedGroup: e.target.value,
    });
  };

  changeSubGroup = (e) => {
    this.setState({
      selectedSubGroup: e.target.value,
    });
  };
 

  handleChangeStation = (e) => {
      this.setState({
        selectedStation: e.target.value,
      });
  };



  assembleDispatchData = (dispatchData) => {
    console.log("dispatchData", dispatchData)
    let DispatchData = dispatchData.map((post, index) => {
    
      return {
        action:<input type="checkbox" value={post.isChecked} checked={post.isChecked} onChange={() => this.checkedSingle(index,post.isChecked, post.id)}/>,       
        sub_group_id: post.sub_group,
        order: post.order_qty,
        total_value: post.total_val,
        scan_qty: post.scan_qty,
        products: post.product,      
      };
    });

    this.setState({
      loading_overlay: false,
      loading: false,
    });

    return DispatchData;
  };


  SearchData(){
    console.log("ARR",this.state.arr_data)
    this.setState({
    loading_overlay: true
    })
    var newArrData = [];
     newArrData = this.state.arr_data.filter(
      (item) => item.party_code == this.state.selectedOutlet || item.distributor_code == this.state.selectedDistributor || item.delivery_center == this.state.selectedLocation || item.outlet_order_no == this.state.selectedOrder
    );
       
    console.log("filterData", newArrData);

    this.setState({
    arr_data: newArrData,
    tableRowsMap: this.assembleDispatchData(newArrData),
    })
  }


  downloadError = () => {
    //this.setState({loading:true})
    const payload = {
      location: this.state.selectedLocation,
      group_id: this.state.selectedGroup,
      station_type: this.state.selectedStation
  };

API.post('/product/product_master/v1/task/fetch/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
        console.log("DataVal", data);
        this.setState({
          //showFetchDispatchData: true,
          loading: false
        });

        window.location.href= data.data[0]
      })
      .catch(function (error) {});
  };

  
  checkAll() {
    if (this.state.isChecked === false) {
      this.setState({
        isChecked: true,
        showSelectedBin: true,
      });

      //let newData = this.state.arr_data

      let newData = this.state.arr_data.map((item) => ({
        ...item,
        isChecked: true,
      }));

      this.setState({
        tableRowsMap: this.assembleDispatchData(newData),
        arr_data: newData,
        //SelectedBins: newBinData,
      });

      /*console.log(this.state.binData);
      this.setState({
        isdisableAssignBtn: false,
      });*/
    } else if (this.state.isChecked === true) {
      this.setState({
        isChecked: false,
        showSelectedBin: false,
      });

      let newData = this.state.arr_data.map((item) => ({
        ...item,
        isChecked: false,
      }));

      this.setState({
        tableRowsMap: this.assembleDispatchData(newData),
        arr_data: newData,
        //SelectedBins: newBinData,
      });

      /*console.log(this.state.binData);
      this.setState({
        isdisableAssignBtn: true,
      });*/
    }
  }


  formatDate = (date) => {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [day, month, year].join('-');
}

 
  convertDate = (inputFormat) => {
  function pad(s) { return (s < 10) ? '0' + s : s; }
  var d = new Date(inputFormat)
  return [d.getFullYear(), pad(d.getMonth()+1), pad(d.getDate())].join('-')
}

  FromDateChange = date  => {
    console.log("Form date", date)
    this.setState({
      fromdate :  date
    }) 
    if(date != null){
    From_Date_val = this.convertDate(date);
    } else{
      From_Date_val= ""
    }
    
    
}

ToDateChange = date => {
    const d = new Date(date);
    this.setState({
      todate :  date
    }) 
    
     if(date != null){
    to_Date_val = this.convertDate(date); 
    } else{
      to_Date_val= ""
    }
}
  
   fetchDispatch = (order_no) => {
    var arr_data = [];
    var total_val = 0;
    var total_qty = 0;
    this.setState({
      //loading_overlay: true,
      loading: true,
    });

    var batch = localStorage.getItem('batch_id');

    const payload = {
      location: this.state.selectedLocation,
      group_id: this.state.selectedGroup,
      station_type: this.state.selectedStation,
      sub_group_id:this.state.selectedSubGroup,
  };

API.post('/product/product_master/v1/order/dashboard/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
        console.log("DataVal", data);
        this.setState({
          showFetchDispatchData: true,
          loading: false
        });

        let AssignData = data.data.map((item) => ({
          ...item,
          isChecked: false,
        }));

        if (data.data.length == 0) {
          this.toggle();
// alert(data.message)
          this.setState({
            dispatch_status: true,
            showFetchDispatchData: false,
            loading_overlay: false,
            loading: false,
            
          });
          return false;
        }

        this.setState({
          orderData: data.data,
          total_value: data.data.total_value,
          total_quantity: data.data.total_qty,
          arr_data: AssignData,
          tableRowsMap: this.assembleDispatchData(AssignData),
          showFetchDispatchData: true,
          dispatch_status: false,
        });
      })
      .catch(function(error) {});
  };

  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    const { modal, modal1, modal2 } = this.state;
    const { SuccessConfirmmodal, Failedmodal } = this.state;

    const dispatchData = {
      columns: [
        {
          label: <input type='checkbox' checked={this.state.isChecked} onChange={() => this.checkAll()} />,

          field: "action",
          width: 100,
        },
        {
          label: "Delivery Line Number",

          field: "del_line_number",
          width: 180,
        },
        {
          label: "Outlet Order Number",

          field: "outlet_order_number",
          width: 180,
        },

        {
          label: "SKU7 Code",

          field: "sku_code",
          width: 120,
        },

        {
          label: "PKD",

          field: "pkd",
          width: 120,
        },
        {
          label: "Distributor Code",

          field: "disc_code",
          width: 145,
        },

        {
            label: "Unique Id",
  
            field: "unique_id",
            width: 120,
          },

          {
            label: "Order Date",
  
            field: "order_date",
            width: 120,
          },
          {
            label: "Retailer Code",
  
            field: "retailer_code",
            width: 120,
          },

          {
            label: "Beat Name",
  
            field: "beat_name",
            width: 180,
          },
          {
            label: "Beat Seq",
  
            field: "beat_seq",
            width: 120,
          },
          {
            label: "Order Qty",
  
            field: "order_qty",
            width: 120,
          },
          {
            label: "Packed Qty",
  
            field: "packed_qty",
            width: 120,
          },
          {
            label: "Exception Qty",
  
            field: "exception_qty",
            width: 120,
          },
          {
            label: "Crate Count",
  
            field: "crate_count",
            width: 120,
          },
          {
            label: "Pick List Update Stamp",
  
            field: "order_date",
            width: 200,
          },

      ],

      rows: this.state.tableRowsMap,
    };

    return (
      <Col xl={16}>
        {this.state.loading_overlay && (
          <LoadingOverlay active={true}  />
        )}
        <Card>
          <CardBody style={{ width:1000 ,paddingTop: 10, height: 56, paddingBottom: 0 }}>
            <form className="form form--block" onSubmit={handleSubmit}>
              <div
                className="form__form-group col-xl-2"
                style={{ marginBottom: "0px" }}
              >
                <div
                  className="form__form-group-field">
                  <select
                    className="form-control"
                    value={this.state.store_id}
                    style={{ fontSize: 13 }}
                    onChange={this.handleChange1}
                  >
                    <option value="">Delivery Line Number</option>
                    {
                      this.state.store.length > 0 &&
                      this.state.store.map((store) => {
                        return (
                          <option value={store.id}> {store.id}</option>
                        );
                      })}
                  </select>
                </div>
              </div>

               <div
                className="form__form-group col-xl-2"
                style={{marginBottom: "0px" }}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <select
                    className="form-control"
                    value={this.state.store_id}
                    style={{ fontSize: 13 }}
                    onChange={this.changeSubGroup}
                  >
                    <option value="">Order Number</option>
                    {
                      this.state.subStore.length > 0 &&
                      this.state.subStore.map((subStore) => {
                        return (
                          <option value={subStore.name}> {subStore.name}</option>
                        );
                      })}
                  </select>
                </div>
              </div>

              <div
                className="form__form-group col-xl-2"
                style={{marginBottom: "0px" }}
              >
                <div
                  className="form__form-group-field"
                >
                  <select
                    className="form-control"
                    value={this.state.store_id}
                    style={{ fontSize: 13 }}
                    onChange={this.handleChangeStation}
                  >
                    <option value="">SKU7 Code</option>
                    {
                      this.state.stationType.length > 0 &&
                      this.state.stationType.map((stationType) => {
                        return (
                          <option value={stationType.name}> {stationType.name}</option>
                        );
                      })}
                  </select>
                </div>
              </div>

              <div
                className="form__form-group col-xl-2"
                style={{
                  display: "inline-block",
                  width: "100%",
                  marginBottom: "0px",
                  paddingTop:"2px",
                }}
              >
                <DatePicker
                  selected={this.state.fromdate}
                  onChange={this.FromDateChange}
                  className="ledger_fromdate"
                  placeholderText="From Date"
                  format="YYYY-MM-dd"
                />
              </div>
        
              <div
                className="form__form-group col-xl-2"
                style={{
                  display: "inline-block",
                  width: "100%",
                  marginBottom: "0px",
                  paddingTop:"2px",
                }}
              >
                <DatePicker
                  selected={this.state.todate}
                  onChange={this.ToDateChange}
                  className="ledger_todate"
                  placeholderText="To Date"
                  format="YYYY-MM-dd"
                />
              </div>

              <div className="form__form-group col-xl-2">
              
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    className="btn-sm button_enable "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }}
                    id="button_enable"
                    
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    Search
                  </Button>
                </ButtonToolbar>
              </div>
             
            </form>
          </CardBody>

          {this.state.showFetchDispatchData && (
            <CardBody style={{ marginTop: 2, paddingTop: 0, paddingBottom: 0 }}>
              
             <div
                className="dispatchData stock_check_data style_table"
                style={{ marginTop: -27 }}
              >

               <Button style={{marginBottom: 0, marginTop:34, paddingTop: 5, paddingBottom:5, paddingLeft: 26, paddingRight: 26 , fontWeight: 'bold'}} variant="warning" onClick={(e) => this.AssignData()}>Send to PTL</Button>
             
                <MDBDataTable
                  scrollX
                  scrollY
                  maxHeight="390px"
                  displayEntries={false}
                  striped
                  bordered
                  data={dispatchData}
                />
              </div>        
            </CardBody>
          )}
        </Card>

        <Modal isOpen={modal} toggle={this.toggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-down modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h4>No Records Available </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.toggleOK}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>
        <Modal isOpen={modal2} toggle={this.toggle2}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle2}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" ,margin:4}}
            />
            <h4>WH activity initiated, Tasks sent to PTL.
              <h4>Continue with Picking Task Assignment</h4> 
              </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.toggle2}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

          <Modal isOpen={Failedmodal} toggle={this.Failedtoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h4>{this.state.failed_message} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.Failedtoggle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>       
      </Col>
    );
  }
}



export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));
